import type { DataSourceDataParams } from "@infinite-table/infinite-react";
import type { PriceDaily } from "epsm-api-types/models";
import { ONE_DAY_IN_MS } from "@/lib/utils";

export function getPriceDataParams(
	ticker: string,
	dateFrom: Date | number = 0,
	dateTo: Date | number = 0,
): Partial<DataSourceDataParams<PriceDaily>> {
	const from = dateFrom instanceof Date ? dateFrom.getTime() : dateFrom;
	const to = dateTo instanceof Date ? dateTo.getTime() : dateTo;

	return {
		filterValue: [
			{
				field: "ticker",
				filter: { operator: "regex", type: "string", value: ticker },
			},
			{
				field: "date",
				filter: {
					operator: "gte",
					type: "date",
					value: from - ONE_DAY_IN_MS * 10,
				},
			},
			{
				field: "date",
				filter: {
					operator: "lte",
					type: "date",
					value: to,
				},
			},
		],
		sortInfo: [
			{
				field: "date",
				dir: 1,
			},
		],
	};
}
